import {
  IK_IDK_QUESTION_ID,
  REASON_NEW_VEHICLE_QUESTION_ID,
  BUDGET_QUESTION_ID,
  FEATURE_QUESTION_ID,
  LIFESTYLE_QUESTION_ID,
  VEHICLE_POWER_QUESTION_ID,
  VEHICLE_TYPE_QUESTION_ID,
  VEHICLE_CONDITION_QUESTION_ID,
  CUSTOMER_INFO_QUESTION_ID,
  TRADE_IN_QUESTION_ID,
  TRADE_IN_PAY_OFF_QUESTION_ID,
  PAYMENT_MODE_QUESTION_ID,
  PICK_CARS_QUESTION_ID,
  MONTHLY_BUDGET_QUESTION_ID,
  SELECTED_VEHICLE_CONFIRMATION_QUESTION_ID,
  CURRENT_CUSTOMER_VEHICLE_QUESTION_ID,
} from "../../constants/questionIds";

export const questionIdToQuizIndexMapping = {
  [IK_IDK_QUESTION_ID]: "IKIDK_INDEX",
  [REASON_NEW_VEHICLE_QUESTION_ID]: "REASON_NEW_VEHICLE_INDEX",
  [BUDGET_QUESTION_ID]: "BUDGET_INDEX",
  [FEATURE_QUESTION_ID]: "FEATURE_SELECT_INDEX",
  [LIFESTYLE_QUESTION_ID]: "LIFESTYLE_INDEX",
  [VEHICLE_POWER_QUESTION_ID]: "VEHICLE_ENGINE_INDEX",
  [VEHICLE_TYPE_QUESTION_ID]: "VEHICLE_TYPE_INDEX",
  [VEHICLE_CONDITION_QUESTION_ID]: "NEW_USED_INDEX",
  [CUSTOMER_INFO_QUESTION_ID]: "USER_DETAILS_INDEX",
  [TRADE_IN_QUESTION_ID]: "TRADE_IN_INDEX",
  [TRADE_IN_PAY_OFF_QUESTION_ID]: "TRADE_IN_PAY_OFF_INDEX",
  [PAYMENT_MODE_QUESTION_ID]: "PAYMENT_MODE_INDEX",
  [PICK_CARS_QUESTION_ID]: "PICK_CARS_INDEX",
  [MONTHLY_BUDGET_QUESTION_ID]: "MONTHLY_BUDGET_INDEX",
  [SELECTED_VEHICLE_CONFIRMATION_QUESTION_ID]:
    "SELECTED_VEHICLE_CONFIRMATION_INDEX",
  [CURRENT_CUSTOMER_VEHICLE_QUESTION_ID]: "CURRENT_CUSTOMER_VEHICLE_INDEX",
};
